import {
  BUSINESS_DEVELOPMENT_DEPARTMENT_MANAGER,
  BUSINESS_DEVELOPMENT_HOD,
  CITY_ADMINISTRATION_DEPARTMENT_MANAGER,
  CITY_ADMINISTRATION_HOD,
  CIVIL_ENGINEERING_HOD,
  CIVIL_ENGINEERING_MANAGER,
  COMMERCIAL_DEPARTMENT_MANAGER,
  COMMERCIAL_HOD,
  ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_CAPEX_MANAGER,
  ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_HOD,
  ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_OPEX_MANAGER,
  FINANCE_AND_ACCOUNTS_DEPARTMENT_MANAGER,
  FINANCE_AND_ACCOUNTS_HOD,
  FINTECH_DEPARTMENT_HOD,
  FINTECH_DEPARTMENT_MANAGER,
  FIRE_AND_LIFE_SAFETY_DEPARTMENT_MANAGER,
  FIRE_AND_LIFE_SAFETY_HOD,
  HUMAN_RESOURCES_DEPARTMENT_MANAGER,
  HUMAN_RESOURCES_HOD,
  IT_DEPARTMENT_MANAGER,
  IT_HOD,
  LEGAL_AND_LAND_DEPARTMENT_MANAGER,
  LEGAL_AND_LAND_HOD,
  MECHANICAL_ENGINEERING_CAPEX_MANAGER,
  MECHANICAL_ENGINEERING_HOD,
  MECHANICAL_ENGINEERING_OPEX_MANAGER,
  PA_AND_E_DEPARTMENT_MANAGER,
  PA_AND_E_HOD,
  PROCUREMENT_CONTRACTS_AND_FINANCE_DEPARTMENT_MANAGER,
  PROCUREMENT_CONTRACTS_AND_FINANCE_HOD,
  SUPER_ADMIN,
  CONSUMER,
  WATER_INFRASTRUCTURE_CAPEX_MANAGER,
  WATER_INFRASTRUCTURE_HOD,
  WATER_INFRASTRUCTURE_OPEX_MANAGER,
  allAdminRoles,
  dcsApplicationsRoles,
  otherUtilitiesRoles,
  powerApplicationsRoles,
  POWER_FINANCE,
} from "./constant";

export const addressOptions = [
  { value: 1, label: "Work" },
  { value: 2, label: "Residential" },
  { value: 3, label: "Permanent" },
];

export const genderOptions = [
  { value: 1, label: "Male" },
  { value: 2, label: "Female" },
  { value: 3, label: "Other" },
];

export const powerAlterationOptions = [
  { value: 1, label: "AddLoad " },
  { value: 2, label: "ChangeLoad" },
  { value: 3, label: "SurrenderLoad" },
];
export const ageCategoryOptions = [
  { value: 1, label: "Adult" },
  { value: 2, label: "Senior Citizen" },
];

export const salutationOptions = [
  { value: 1, label: "Mr" },
  { value: 2, label: "Mrs" },
  { value: 3, label: "Ms" },
  { value: 4, label: "Mx. (Transgender)" },
];

export const ltLoadOptions = [{ value: 1, label: "Single Phase" }];

export const loadOptions = [
  { value: 1, label: "Single Phase" },
  { value: 2, label: "Three Phase" },
];

export const timeshiftingOptions = [
  { value: 1, label: "24 Hours" },
  { value: 2, label: "Night Hours (10PM to 6AM)" },
];

export const unitOptions = [
  { value: 1, label: "kW" },
  { value: 2, label: "kVA" },
  { value: 3, label: "HP" },
  { value: 4, label: "V" },
  { value: 5, label: "kV" },
  { value: 6, label: "kWH" },
  { value: 7, label: "kVAH" },
  { value: 8, label: "kVARH" },
  { value: 9, label: "TR" },
  { value: 10, label: "SQ M" },
  { value: 11, label: "LITERS/DAY" },
  { value: 12, label: "MM" },
  { value: 13, label: "LITERS/SECOND" },
];

export const accessoryType = [
  { value: 1, label: "Material" },
  { value: 2, label: "Labour" },
  { value: 3, label: "Both" },
];

export const solarTypeOptions = [
  { value: 1, label: "Rooftop" },
  { value: 2, label: "Ground Mounted " },
];

export const solarUsagePurposeOptions = [
  { value: 1, label: "Captive consumption" },
  { value: 2, label: "Sale to GIFT Power" },
  { value: 3, label: "Sale to Third Party" },
  { value: 4, label: "RPO Compliance" },
];

export const solarVolatgeUnit = [
  {
    value: 1,
    label: "kW",
  },
];

export const energySettlementOptions = [
  { value: 1, label: "Consumer utilizes only energy attribute" },
  {
    value: 2,
    label:
      "Consumer utilizes the energy attribute and not registered under REC mechanism",
  },
  {
    value: 3,
    label:
      "Consumer utilizes the energy attribute and utilize the renewable attribute for RPO compliance",
  },
  {
    value: 4,
    label:
      "Consumer utilizes the energy attribute and utilize the renewable attribute for REC.",
  },
];

export const openAccessPowerOptions = [
  { value: 1, label: "STOA" },
  { value: 2, label: "MTOA" },
  { value: 3, label: "LTOA" },
  { value: 4, label: "N/A" },
];

export const powerRequirementOptions = [
  { value: 1, label: "HT" },
  { value: 2, label: "LT" },
];

export const severityOptions = [
  { value: 1, label: "High" },
  { value: 2, label: "Medium" },
  { value: 3, label: "Low" },
];

export const complaintStatus = [
  { value: 1, label: "Created" },
  { value: 2, label: "Open" },
  { value: 3, label: "Close" },
];

export const subscriptionTypes = [
  {
    value: 1,
    label: "Electricity",
    allowedRoles: [CONSUMER, SUPER_ADMIN, ...powerApplicationsRoles],
  },
  {
    value: 2,
    label: "Security Deposit",
    allowedRoles: [SUPER_ADMIN, ...powerApplicationsRoles],
  },
  {
    value: 3,
    allowedRoles: [CONSUMER, SUPER_ADMIN, ...powerApplicationsRoles],
    label: "Backup Power",
  },
  {
    value: 4,
    label: "DCS",
    allowedRoles: [CONSUMER, SUPER_ADMIN, ...dcsApplicationsRoles],
  },
  {
    value: 5,
    label: "Water",
    allowedRoles: [CONSUMER, SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 6,
    label: "Sewage",
    allowedRoles: [CONSUMER, SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 7,
    label: "Solid Waste",
    allowedRoles: [CONSUMER, SUPER_ADMIN, ...otherUtilitiesRoles],
  },
];

export const billingSubscriptionTypes = [
  {
    value: 1,
    label: "Electricity",
    allowedRoles: [SUPER_ADMIN, ...powerApplicationsRoles],
  },
  {
    value: 4,
    label: "DCS",
    allowedRoles: [SUPER_ADMIN, ...dcsApplicationsRoles],
  },
  {
    value: 5,
    label: "Water",
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 6,
    label: "Sewage",
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 7,
    label: "Solid Waste",
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
];
export const outStandingReportBillingSubTypes = [
  {
    value: 1,
    label: "Electricity",
    allowedRoles: [SUPER_ADMIN, ...powerApplicationsRoles],
  },
  {
    value: 4,
    label: "DCS",
    allowedRoles: [SUPER_ADMIN, ...dcsApplicationsRoles],
  },
  {
    value: 5,
    label: "Water",
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 6,
    label: "Sewage",
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 7,
    label: "Solid Waste",
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 3,
    label: "Backup Power",
    allowedRoles: [SUPER_ADMIN, POWER_FINANCE],
  },
];

export const offlinePaymentSubscriptionTypes = [
  {
    value: 1,
    label: "Electricity",
    allowedRoles: [SUPER_ADMIN, ...powerApplicationsRoles],
    utilityId: 1,
  },
  {
    value: 2,
    label: "Security Deposit",
    utilityId: 1,
    allowedRoles: [SUPER_ADMIN, ...powerApplicationsRoles],
  },
  {
    value: 3,
    utilityId: 1,
    allowedRoles: [SUPER_ADMIN, ...powerApplicationsRoles],
    label: "Backup Power",
  },
  {
    value: 4,
    label: "DCS",
    utilityId: 2,
    allowedRoles: [SUPER_ADMIN, ...dcsApplicationsRoles],
  },
  {
    value: 5,
    label: "Water",
    utilityId: 3,
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 6,
    utilityId: 4,
    label: "Sewage",
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 7,
    label: "Solid Waste",
    utilityId: 5,
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    value: 8,
    label: "Demand Estimate",
    allowedRoles: allAdminRoles,
  },
];

export const billingStatus = [
  {
    value: 1,
    label: "Initiated",
  },
  { value: 2, label: "In Progress" },
  {
    value: 3,
    label: "Executed",
  },
  {
    value: 4,
    label: "Approved",
  },
  {
    value: 5,
    label: "Dispatched",
  },
  {
    value: 6,
    label: "Closed",
  },
  {
    value: 7,
    label: "Pre-Active",
  },
];

export const billCalculationStatus = [
  {
    value: 1,
    label: "Default",
  },
  {
    value: 2,
    label: "Approved",
  },
  {
    value: 3,
    label: "Signed",
  },
  {
    value: 4,
    label: "Dispatched",
  },
  {
    value: 5,
    label: "Paid",
  },
  {
    value: 6,
    label: "Unpaid",
  },
];

export const moduleTypes = [
  {
    value: 1,
    label: "Demand Estimate",
  },
  {
    value: 2,
    label: "Billing",
  },
  {
    value: 3,
    label: "Security Deposit Billing",
  },
  {
    value: 4,
    label: "Backup Power Billing",
  },
  {
    value: 5,
    label: "Refund",
  },
  {
    value: 6,
    label: "Other",
  },
  {
    value: 7,
    label: "DCS Billing",
  },
  {
    value: 8,
    label: "Water Billing",
  },
  {
    value: 9,
    label: "Sewage Billing",
  },
  {
    value: 10,
    label: "Solid Waste Billing",
  },
];

const notificationTypes = [
  {
    value: 1,
    label: "Application",
  },
  {
    value: 2,
    label: "BillingCycle",
  },
  {
    value: 3,
    label: "ConsumerComplaint",
  },
  { value: 4, label: "TechnicalSanction" },
  { value: 5, label: "SecurityDeposit" },
  { value: 6, label: "DemandEstimate" },
  { value: 7, label: "Default" },
  { value: 8, label: "OtherUtilityApplication" },
];

const applicationActionTypes = [
  {
    value: 1,
    label: "Approved",
  },
  {
    value: 2,
    label: "Rejected",
  },
  {
    value: 3,
    label: "Revoked",
  },
];

export const powerApplicationTypes = [
  {
    value: 1,
    label: "Permanent Connection",
  },
  {
    value: 2,
    label: "Temporary Connection",
  },
  {
    value: 3,
    label: "NameChange Transfer",
  },
  {
    value: 4,
    label: "Demand Reduction",
  },
  {
    value: 5,
    label: "Demand Extension",
  },
  {
    value: 6,
    label: "Premise Amalgamation",
  },
  {
    value: 7,
    label: "Premise Removal",
  },
  {
    value: 8,
    label: "Shifting of Service",
  },
  {
    value: 9,
    label: "Change of Category",
  },
  {
    value: 10,
    label: "Net Metering",
  },
  {
    value: 11,
    label: "Backup Power",
  },
  {
    value: 12,
    label: "Removal of Connection",
  },
];

export const connectionApplicationTypes = [
  {
    value: 1,
    label: "Permanent Connection",
  },
  {
    value: 2,
    label: "Temporary Connection",
  },
];

export const chargeTypes = [
  { value: 1, label: "Demand" },
  { value: 2, label: "Energy" },
  { value: 3, label: "Fuel" },
  { value: 4, label: "TimeOfUsage" },
  { value: 5, label: "ElectricityDuty" },
  { value: 6, label: "RebateOfSupply" },
  { value: 7, label: "MF" },
  { value: 8, label: "MaxDemand" },
  { value: 9, label: "LoadFactor" },
  { value: 10, label: "PowerFactor" },
  { value: 11, label: "BaseDemand" },
  { value: 12, label: "ConnectionCharge" },
  { value: 13, label: "RegistrationFee" },
  { value: 14, label: "TestReportFee" },
  { value: 15, label: "SupervisionCharges" },
  { value: 16, label: "LabourCharges" },
  { value: 17, label: "MaterialCharges" },
  { value: 18, label: "SecurityDeposit" },
  { value: 19, label: "BackupPowerCapitalCost_DTA" },
  { value: 20, label: "BackupPowerCapitalCost_SEZ" },
  { value: 21, label: "NightHourRebate" },
  { value: 22, label: "PFAdjustmentCharges" },
  { value: 23, label: "PeakHourCharges" },
  { value: 24, label: "DelayPaymentCharges" },
  { value: 25, label: "GreenPower" },
  { value: 26, label: "ReactiveCharges" },
  { value: 27, label: "OffPeakRebate" },
  { value: 28, label: "ActualMaxDemand" },
];

export const tariffTypes = [
  { value: 1, label: "RGP" },
  { value: 2, label: "Non-RGP" },
  { value: 3, label: "Non-RGP-Night" },
  // { value: 4, label: "RGP-Rural" },
  { value: 5, label: "LTMD" },
  { value: 6, label: "LTMD-Night" },
  { value: 7, label: "GLP" },
  { value: 8, label: "WWSP-Type-I" },
  { value: 9, label: "WWSP-Type-II" },
  // { value: 10, label: "WWSP-Type-III" },
  { value: 11, label: "TMP" },
  { value: 12, label: "LTEVCS" },
  { value: 13, label: "HTEVCS" },
  { value: 14, label: "HTP-I" },
  { value: 15, label: "HTP-II" },
  { value: 16, label: "HTP-III" },
  { value: 17, label: "HTP-IV" },
  // { value: 18, label: "HTP-V" },
  // { value: 19, label: "AG" },
];

export const tariff = [
  { value: 1, label: "RGP" },
  { value: 2, label: "Non RGP" },
  { value: 3, label: "Non RGP Night" },
  // { value: 4, label: "RGP Rural" },
  { value: 5, label: "LTMD" },
  { value: 6, label: "LTMD Night" },
  { value: 7, label: "GLP" },
  { value: 8, label: "WWSP" },
  { value: 9, label: "TMP" },
  { value: 10, label: "LTEVCS" },
  { value: 11, label: "HTEVCS" },
  { value: 12, label: "HTP I" },
  { value: 13, label: "HTP II" },
  { value: 14, label: "HTP III" },
  { value: 15, label: "HTP IV" },
  // { value: 16, label: "HTP V" },
  // { value: 17, label: "AG" },

  { value: 18, label: "Domestic" },
  { value: 19, label: "Non Domestic" },
  { value: 20, label: "Residential" },
  { value: 21, label: "Commercial" },
  { value: 22, label: "Institutional" },
];

export const meterTypes = [
  { value: 101, label: "Liberty 200" },
  { value: 105, label: "Liberty 500" },
  { value: 501, label: "LT CT Premier 500" },
  { value: 505, label: "HT Premier 500" },
];

export const documentRequiredEnum = [
  { value: 1, label: "required" },
  { value: 2, label: "partiallyRequired" },
  { value: 3, label: "optional" },
];

export const utilityConsumerStatus = [
  { value: "", label: "All" },
  {
    value: true,
    label: "Active",
  },
  {
    value: false,
    label: "Disconnected",
  },
];

export const applicationApprovalPendingStatus = [
  { value: "", label: "All" },
  {
    value: true,
    label: "Approval Pending Application",
  },
  {
    value: false,
    label: "Approved",
  },
];

export const reportOptions = [
  {
    label: "Application Status History-All",
    value: 1,
  },
  {
    label: "List of Application",
    value: 2,
  },
  {
    label: "Monthly Application Count",
    value: 3,
  },
  {
    label: "Consumer Master Data",
    value: 4,
  },
  {
    label: "Consumer Data",
    value: 5,
  },
  {
    label: "Active and Disconnected Tariff Wise",
    value: 6,
  },
  {
    label: "Active and Disconnected Category Wise",
    value: 7,
  },
  {
    label: "Contact Details",
    value: 8,
  },
  {
    label: "Backup Power Details",
    value: 9,
  },
  {
    label: "Net Metering",
    value: 10,
  },
  {
    label: "Number of Complaints",
    value: 11,
  },
  {
    label: "GERC",
    value: 12,
  },
  {
    label: "Maximum Demand-Consumer Wise",
    value: 13,
  },
  // {
  //   label: "Maximum Demand-TR Wise",
  //   value: 14,
  // },
  {
    label: "Category Wise Connected Load",
    value: 15,
  },
  {
    label: "Asset Details",
    value: 16,
  },
  {
    label: "Metering Status",
    value: 17,
  },
  {
    label: "SIM Details",
    value: 18,
  },
  {
    label: "Consumer Category Wise",
    value: 19,
  },
  {
    label: "Consumer Tariff Wise",
    value: 20,
  },
  {
    label: "Billing Calculation",
    value: 21,
  },
  {
    label: "Dispatched Bills",
    value: 22,
  },
  {
    label: "Power Abstract",
    value: 23,
  },
  {
    label: "Invoice Uploader",
    value: 24,
  },
  {
    label: "Consumer Virtual Account",
    value: 25,
  },
  {
    label: "Monthly Application Summary (MIS)",
    value: 26,
  },
  {
    label: "Backup Power Invoice Report",
    value: 30,
  },
  {
    label: "Backup Power Abstract Report",
    value: 31,
  },
  {
    label: "Service Line Contribution Bifurcation Report",
    value: 33,
  },
  {
    label: "Power Consumer Security Deposit Report",
    value: 34,
  },
  {
    label: "Backup Power Dispatched Bills Report",
    value: 35,
  },
  {
    label: "Consumer-Wise Tax Invoice",
    value: 36,
  },
];

export const reportOptionsForDcs = [
  {
    label: "DCS SAP Sales Order Charges",
    value: 27,
  },
  {
    label: "DCS Consumer Master Data Report",
    value: 28,
  },
  {
    label: "DCS Name Change Details Report",
    value: 29,
  },
  {
    label: "Consumer Wise Bill Report",
    value: 32,
  },
];

export const fireSafetyReportOptions = [
  {
    label: "Building Compliance",
    value: 1,
  },
  {
    label: "Common Inspection Observation",
    value: 2,
  },
  // {
  //   label: "Overall Compliance (City Level)",
  //   value: 3,
  // },
  { label: "Inspection Status", value: 4 },
  { label: "Compliance Rate Over Time", value: 5 },
  { label: "Building Observation", value: 6 },
  { label: "Building Non-Compliance Status", value: 7 },
];

export const reportTypeEnum = [
  {
    value: 1,
    label: "New Connection",
  },
  {
    value: 2,
    label: "Name Change",
  },
  {
    value: 3,
    label: "Disconnection",
  },
];

export const adminComments = [
  {
    value: 1,
    label: "Application",
  },
  {
    value: 2,
    label: "BillingCalculation",
  },
  {
    value: 3,
    label: "SecurityDeposit",
  },
  {
    value: 4,
    label: "TechnicalSanction",
  },
];

const documentEnum = [
  {
    value: 1,
    label: "Application",
  },
  {
    value: 2,
    label: "Demand_Estimate",
  },
  {
    value: 3,
    label: "Technical_Sanction",
  },
];

export const occupancyType = [
  {
    value: 1,
    label: "Owner",
  },
  {
    value: 2,
    label: "Joint Owner",
  },
  {
    value: 3,
    label: "Tenant",
  },
  {
    value: 4,
    label: "Lease",
  },
];

export const occupancyTypeForPower = [
  ...occupancyType,
  {
    value: 5,
    label: "Co Lessee",
  },
];

const homeContentType = [
  {
    value: 1,
    label: "Text",
  },
  {
    value: 2,
    label: "Document",
  },
];

export const utilityConsumerStatusEnum = [
  { value: "", label: "All" },
  { value: 1, label: "Created" },
  { value: 2, label: "Activated" },
  { value: 3, label: "Temporary Disconnected" },
  { value: 4, label: "Disconnected" },
];

export const calculationStatusEnum = [
  { value: "", label: "All" },
  { value: 1, label: "Default" },
  { value: 2, label: "Approved" },
  { value: 3, label: "Signed" },
  { value: 4, label: "Dispatched" },
  { value: 5, label: "Paid" },
];

export const consumerStatusOptions = [
  { label: "All", value: "" },
  { label: "Dispatched", value: 4 },
  { label: "Paid", value: 5 },
];

export const otherUtilityApplicationOptions = [
  { label: "DCS", value: 2 },
  { label: "Water", value: 3 },
  { label: "Sewage", value: 4 },
  { label: "Solid Waste", value: 5 },
];

export const temporaryApplicationOtherUtilityOptions = [
  { label: "DCS", value: 2 },
  { label: "Water", value: 3 },
  { label: "Sewage", value: 4 },
];

export const utilityOptions = [
  {
    label: "Power",
    value: 1,
    allowedRoles: [SUPER_ADMIN, ...powerApplicationsRoles],
  },
  {
    label: "DCS",
    value: 2,
    allowedRoles: [SUPER_ADMIN, ...dcsApplicationsRoles],
  },
  {
    label: "Water",
    value: 3,
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    label: "Sewage",
    value: 4,
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
  {
    label: "Solid Waste",
    value: 5,
    allowedRoles: [SUPER_ADMIN, ...otherUtilitiesRoles],
  },
];

export const billingOptionsForDispatchBills = [{ label: "Approved", value: 2 }];

export const backupPowerForDispatchBillingOption = [
  { label: "Signed", value: 3 },
];

export const billingOptionsForOtherUtilityDispatchBills = [
  { label: "Signed", value: 3 },
];

export const gstOptions = [
  { label: "Registered", value: true },
  { label: "Unregistered", value: false },
];

export const paymentModeOptions = [
  { label: "Online", value: false },
  { label: "Offline", value: true },
];

export const paymentModeEnum = [
  {
    label: "Cash",
    value: 1,
  },
  {
    label: "Cheque",
    value: 2,
  },
  {
    label: "RTGS/NEFT",
    value: 3,
  },
  {
    label: "Demand Draft",
    value: 4,
  },
];

export const utilityOptionsForUser = [
  { label: "Power", value: 1 },
  { label: "DCS", value: 2 },
  { label: "Water, Sewage, Solid Waste", value: 3 },
];

export const requirementOptions = [
  {
    label: "MaterialSupply",
    value: 1,
  },
  {
    label: "Service",
    value: 2,
  },
  {
    label: "SITC",
    value: 3,
  },
];

export const natureOfWorkOptions = [
  {
    label: "Maintenance",
    value: 1,
  },
  {
    label: "Breakdown",
    value: 2,
  },
  {
    label: "Replacement",
    value: 3,
  },
  {
    label: "Project",
    value: 4,
  },
  {
    label: "Connection",
    value: 5,
  },
  {
    label: "Emergency",
    value: 6,
  },
  {
    label: "Consulting",
    value: 7,
  },
];

export const premiseAreaEnum = [
  {
    label: "DTA",
    value: 1,
  },
  {
    label: "SEZ-PA",
    value: 2,
  },
  { label: "SEZ-NPA", value: 3 },
];

export const chargeModule = [
  {
    label: "Default",
    value: 1,
  },
  {
    label: "Demand Estimates",
    value: 2,
  },
  {
    label: "Technical Sanction",
    value: 3,
  },
  {
    label: "Backup Power",
    value: 4,
  },
];

export const dcsConnectionTypeEnum = [
  { label: "Building", value: 1 },
  { label: "Individual Units", value: 2 },
];

export const dcsIndividualUnitTypeEnum = [
  { label: "Residential Units", value: 1 },
  { label: "Shops Offices And Others Units", value: 2 },
];

export const otherUtilityMeterSubscriptionOptions = [
  { label: "DCS", value: 4, utilityId: 2 },
  { label: "Water & Sewage", value: 5, utilityId: 3 },
];

export const otherUtilitySubscriptionOptions = [
  { label: "DCS", value: 4, utilityId: 2 },
  { label: "Water", value: 5, utilityId: 3 },
  { label: "Solid Waste", value: 7, utilityId: 5 },
];

export const otherUtilitySubscriptionTypes = [
  { label: "DCS", value: 4, utilityId: 2 },
  { label: "Water", value: 5, utilityId: 3 },
  { label: "Sewage", value: 6, utilityId: 4 },
  { label: "Solid Waste", value: 7, utilityId: 5 },
];

export const otherUtilityBillingOptions = [
  { label: "DCS", value: 2, subscriptionType: 4 },
  { label: "Water", value: 3, subscriptionType: 5 },
  { label: "Sewage", value: 4, subscriptionType: 6 },
  { label: "Solid Waste", value: 5, subscriptionType: 7 },
];

export const connectionTypeEnum = [
  { value: 20, label: "Residential" },
  { value: 21, label: "Commercial" },
];

export const cgrfStatus = [
  { label: "Saved", value: 1 },
  { label: "Submitted", value: 2 },
  { label: "Closed", value: 3 },
];

export const fireSafetyDepartments = [
  { value: 1, label: "Fire And Emergency Services" },
  { value: 2, label: "ICT" },
  { value: 3, label: "Planning" },
  { value: 4, label: "Electrical" },
  { value: 5, label: "Mechanical" },
];

export const utilityTunnelDepartments = [
  {
    value: 1,
    label: "Electrical And Instrumentation Engineering",
    managerRoles: [
      ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_CAPEX_MANAGER,
      ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_OPEX_MANAGER,
    ],
    hodRole: [ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_HOD],
    isCapexOpex: true,
  },
  {
    value: 2,
    label: "Mechanical Engineering",
    managerRoles: [
      MECHANICAL_ENGINEERING_CAPEX_MANAGER,
      MECHANICAL_ENGINEERING_OPEX_MANAGER,
    ],
    hodRole: [MECHANICAL_ENGINEERING_HOD],
    isCapexOpex: true,
  },
  {
    value: 3,
    label: "Water Infrastructure",
    managerRoles: [
      WATER_INFRASTRUCTURE_CAPEX_MANAGER,
      WATER_INFRASTRUCTURE_OPEX_MANAGER,
    ],
    hodRole: [WATER_INFRASTRUCTURE_HOD],
    isCapexOpex: true,
  },
  {
    value: 4,
    label: "Civil Engineering",
    managerRoles: [CIVIL_ENGINEERING_MANAGER],
    hodRole: [CIVIL_ENGINEERING_HOD],
  },
  {
    value: 5,
    label: "IT",
    managerRoles: [IT_DEPARTMENT_MANAGER],
    hodRole: [IT_HOD],
  },
  {
    value: 6,
    label: "Fire And LifeSafety",
    managerRoles: [FIRE_AND_LIFE_SAFETY_DEPARTMENT_MANAGER],
    hodRole: [FIRE_AND_LIFE_SAFETY_HOD],
  },
  {
    value: 7,
    label: "Human Resources",
    managerRoles: [HUMAN_RESOURCES_DEPARTMENT_MANAGER],
    hodRole: [HUMAN_RESOURCES_HOD],
  },
  {
    value: 8,
    label: "Finance And Accounts",
    managerRoles: [FINANCE_AND_ACCOUNTS_DEPARTMENT_MANAGER],
    hodRole: [FINANCE_AND_ACCOUNTS_HOD],
  },
  {
    value: 9,
    label: "Fintech Department",
    managerRoles: [FINTECH_DEPARTMENT_MANAGER],
    hodRole: [FINTECH_DEPARTMENT_HOD],
  },
  {
    value: 10,
    label: "PA And E",
    managerRoles: [PA_AND_E_DEPARTMENT_MANAGER],
    hodRole: [PA_AND_E_HOD],
  },
  {
    value: 11,
    label: "Procurement Contracts And Finance",
    managerRoles: [PROCUREMENT_CONTRACTS_AND_FINANCE_DEPARTMENT_MANAGER],
    hodRole: [PROCUREMENT_CONTRACTS_AND_FINANCE_HOD],
  },
  {
    value: 12,
    label: "Legal And Land",
    managerRoles: [LEGAL_AND_LAND_DEPARTMENT_MANAGER],
    hodRole: [LEGAL_AND_LAND_HOD],
  },
  {
    value: 13,
    label: "Business Development",
    managerRoles: [BUSINESS_DEVELOPMENT_DEPARTMENT_MANAGER],
    hodRole: [BUSINESS_DEVELOPMENT_HOD],
  },
  {
    value: 14,
    label: "City Administration",
    managerRoles: [CITY_ADMINISTRATION_DEPARTMENT_MANAGER],
    hodRole: [CITY_ADMINISTRATION_HOD],
  },
  {
    value: 15,
    label: "Commercial",
    managerRoles: [COMMERCIAL_DEPARTMENT_MANAGER],
    hodRole: [COMMERCIAL_HOD],
  },
];

export const utilityTunnelUserType = [
  { value: 1, label: "UTACardIssuanceSuperAdmin" },
  { value: 2, label: "HOD" },
  { value: 3, label: "DepartmentManager" },
  { value: 4, label: "CapExManager" },
  { value: 5, label: "OpexManager" },
  { value: 6, label: "CardIssuerInCharge" },
  { value: 7, label: "Employee" },
  { value: 8, label: "Contractor" },
];

export const capexOpexOptionsType = [
  { label: "Project / CapEx", value: 4 },
  { label: "O&M / OpEx", value: 5 },
];

export const utilityTunnelConsumerType = [
  { value: 1, label: "Employee" },
  { value: 2, label: "Contractor" },
];

export const utilityTunnelIssuanceRoleType = [
  { value: 4, label: "CapEx Manager" },
  { value: 5, label: "Opex Manager" },
];

// enums for fire Safety Module

export const typeOfOccupancyOptions = [
  { label: "Residential", value: 1 },
  { label: "Educational", value: 2 },
  { label: "Institutional", value: 3 },
  { label: "Assembly", value: 4 },
  { label: "Business", value: 5 },
  { label: "Mercantile", value: 6 },
  { label: "Industries", value: 7 },
  { label: "Storage", value: 8 },
  { label: "Hazardous", value: 9 },
  { label: "Mixed Occupancy", value: 10 },
];

export const fireWaterStorageTankTypeEnum = [
  {
    label: "UnderGroundTank",
    value: 1,
  },
  { label: "OverHeadTank", value: 2 },
];

export const fireVentilationTypeEnum = [
  { label: "Natural", value: 1 },
  { label: "Mechanical", value: 2 },
];

export const fireFightingPumpTypeEnum = [
  {
    label: "Jockey",
    value: 1,
  },
  {
    label: "Hydrant",
    value: 2,
  },
  {
    label: "Sprinkler",
    value: 3,
  },
  {
    label: "Diesel",
    value: 4,
  },
  {
    label: "WaterCurtain",
    value: 5,
  },
  {
    label: "Mist",
    value: 6,
  },
];

export const firePumpBuildTypeEnum = [
  { label: "Submersible", value: 1 },
  { label: "Monoblock", value: 2 },
];

export const transformerTypeEnum = [
  { label: "Oil", value: 1 },
  { label: "Dry", value: 2 },
];

export const transformerLocationEnum = [
  {
    label: "Inside",
    value: 1,
  },
  { label: "Outside", value: 2 },
];

export const buildingAuthorityRoleEnum = [
  { label: "Developer", value: 1 },
  { label: "Builder", value: 2 },
  { label: "Owner", value: 3 },
  { label: "Chairman", value: 4 },
  { label: "Occupier", value: 5 },
  { label: "Secretary", value: 6 },
  { label: "Responsible Person", value: 7 },
];

export const buildingAuthorityRole1Enum = [
  { label: "Developer", value: 1 },
  { label: "Builder", value: 2 },
  { label: "Owner", value: 3 },
];

export const buildingAuthorityRole2Enum = [
  { label: "Owner", value: 3 },
  { label: "Chairman", value: 4 },
  { label: "Occupier", value: 5 },
  { label: "Secretary", value: 6 },
];

export const fireExtinguisherTypeEnum = [
  { label: "CO2", value: 1 },
  { label: "Foam", value: 2 },
  { label: "ABC", value: 3 },
  { label: "WaterCO2", value: 4 },
  { label: "DCP", value: 5 },
  { label: "CleanAgent", value: 6 },
  { label: "KType", value: 7 },
  { label: "Modular", value: 8 },
];

export const fireOperationTypeEnum = [
  { label: "AFDAS", value: 1 },
  { label: "MOFAS", value: 2 },
];

export const fireDetectionTypeEnum = [
  { label: "Smoke Detector", value: 1 },
  { label: "Heat Detector", value: 2 },
  { label: "Multi Detector", value: 3 },
  { label: "Beam Detector", value: 4 },
  { label: "Hooter Cum Flasher", value: 5 },
  { label: "Manual Call Point", value: 6 },
  { label: "Gas Leak Detection System", value: 7 },
];

export const planOfActionEnum = [
  { label: "Less Than Seven Days", value: 1 },
  { label: "More Than Seven Days", value: 2 },
];

export const severityEnum = [
  { label: "Low", value: 1 },
  { label: "Medium", value: 2 },
  { label: "High", value: 3 },
];

export const urgencyEnum = [
  { label: "Fifteen Days", value: 1 },
  { label: "One Month", value: 2 },
  { label: "One And A Half Month", value: 3 },
  { label: "Two Month", value: 4 },
];

export const halfYearEnum = [
  { label: "First Half", value: 1 },
  { label: "Second Half", value: 2 },
];

export const sprinklerTypeEnum = [
  { label: "Pendant", value: 1 },
  { label: "Upright", value: 2 },
  { label: "Sidewall", value: 3 },
  { label: "Open Nozzle", value: 4 },
];

export const waterDeveloperTypeEnum = [
  { label: "Construction", value: 1 },
  { label: "Treated", value: 2 },
];

export const areaCategoryEnum = [
  { label: "Tenant", value: 1 },
  { label: "Common Area", value: 2 },
];

export const monthEnum = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const complianceStatusEnum = [
  { label: "Complied", value: 1 },
  { label: "Work In Progress", value: 2 },
];

export const mockDrillStatusEnum = [
  { label: "Scheduled", value: 1 },
  { label: "Developer Intimation", value: 2 },
  { label: "Report Submitted", value: 3 },
];

export const communicationOption = [
  { label: "Email", value: 1 },
  { label: "SMS", value: 2 },
  { label: "Whatsapp", value: 3 },
];

export const languageEnum = [
  { label: "en", value: 1 },
  { label: "hi", value: 2 },
  { label: "gu", value: 3 },
];

const enums = {
  connectionTypeEnum,
  addressOptions,
  genderOptions,
  ageCategoryOptions,
  salutationOptions,
  timeshiftingOptions,
  unitOptions,
  loadOptions,
  powerAlterationOptions,
  accessoryType,
  dcsConnectionTypeEnum,
  dcsIndividualUnitTypeEnum,
  solarTypeOptions,
  solarUsagePurposeOptions,
  energySettlementOptions,
  offlinePaymentSubscriptionTypes,
  openAccessPowerOptions,
  solarVolatgeUnit,
  powerRequirementOptions,
  severityOptions,
  complaintStatus,
  subscriptionTypes,
  billCalculationStatus,
  utilityOptionsForUser,
  billingStatus,
  chargeTypes,
  tariffTypes,
  tariff,
  paymentModeEnum,
  meterTypes,
  otherUtilityMeterSubscriptionOptions,
  otherUtilitySubscriptionOptions,
  moduleTypes,
  notificationTypes,
  applicationActionTypes,
  powerApplicationTypes,
  reportOptions,
  documentRequiredEnum,
  utilityConsumerStatus,
  applicationApprovalPendingStatus,
  adminComments,
  documentEnum,
  occupancyType,
  occupancyTypeForPower,
  homeContentType,
  utilityConsumerStatusEnum,
  consumerStatusOptions,
  utilityOptions,
  otherUtilityApplicationOptions,
  billingOptionsForDispatchBills,
  requirementOptions,
  natureOfWorkOptions,
  premiseAreaEnum,
  reportTypeEnum,
  fireWaterStorageTankTypeEnum,
  fireVentilationTypeEnum,
  typeOfOccupancyOptions,
  fireFightingPumpTypeEnum,
  firePumpBuildTypeEnum,
  fireOperationTypeEnum,
  buildingAuthorityRoleEnum,
  fireExtinguisherTypeEnum,
  buildingAuthorityRole2Enum,
  buildingAuthorityRole1Enum,
  transformerLocationEnum,
  transformerTypeEnum,
  planOfActionEnum,
  severityEnum,
  urgencyEnum,
  halfYearEnum,
  fireSafetyReportOptions,
  waterDeveloperTypeEnum,
  billingSubscriptionTypes,
  fireDetectionTypeEnum,
  sprinklerTypeEnum,
  areaCategoryEnum,
  otherUtilitySubscriptionTypes,
  utilityTunnelConsumerType,
  utilityTunnelUserType,
  utilityTunnelDepartments,
  utilityTunnelIssuanceRoleType,
  capexOpexOptionsType,
  cgrfStatus,
  complianceStatusEnum,
  mockDrillStatusEnum,
  languageEnum,
};

export const getOptionLabel = (enumName = "", value = 0) =>
  enums[enumName]?.find((option) => option.value === value)?.label || "";

export const getOptionValue = (enumName = "", label = "") =>
  enums[enumName]?.find((option) => option.label === label)?.value || "";
